import {useState, useEffect} from 'react'

export const useFetch = (url,key,delay=0) => {
  const [data, setData] = useState({[key]:false})
  useEffect(() => {
    let active = url ? true : false
    const fetchData = async () => {
      if (delay) await new Promise(r => setTimeout(r, delay))
      const response = active ? await fetch(url) : false
      const json = active ? await response.json() : false
      if (active) setData({[key]:json})
    }
    if (url) fetchData()
    return () => active = false
  }, [url,key,delay])
  return data
}
export default useFetch
